<template>
  <div :class="{english:$i18n.locale=='en'}">
      <headerLine ref="dialog" showbar="true" @on-locale-change="onLocaleChange" index="9">
        {{$t('technology.name')}}
      </headerLine>  
      <div class="banner">
          <img :src="imglist[0]" alt="">    
          <h1 class="banner_title">
            THE HIGHWAY TO ULTRA HD
          </h1>
<!--           <div class="banner_text" v-html="$t('technology.text1')">
            威尔云 · 创建VR高速公路
          </div>   -->
      </div>
      <div class="content center">
        <div class="content_item">
          <h3 class="content_item_title" v-html="$t('technology.text2')" >
            挑战高清极限：4K，6K，8K
          </h3>
          <div class="content_item_text content_item_text1" v-html="$t('technology.text3')"style="width:90%;margin-left:auto;margin-right:auto;text-align:justify">
            威尔直播自研VR高清直播／点播编解码算法，
          </div>

          <img v-if="$i18n.locale=='ch'" v-lazy="imglist[1]" alt="" style="width:6.85rem;height:3.2rem;margin-right:auto;margin-left:auto">
          <img v-if="$i18n.locale=='en'" v-lazy="imglist[9]" alt="" style="width:6.85rem;height:3.2rem;margin-right:auto;margin-left:auto">

          <div class="compareWords clearfix" style="margin-top:0.4rem">
            <div class="fl">
              <div class="center" v-html="$t('technology.text30')"></div>
            </div>
            <div class="fr">
              <div class="center" v-html="$t('technology.text31')"></div>
            </div>
          </div>
          <div class="compareWords" style="margin-top:0.4rem">
            <div class="center" v-html="$t('technology.text32')" style="margin-bottom:0.7rem">
              
            </div>
          </div>
        </div>
        <div class="" >
          <div class="content_item clearfix" style="background:#f3faff;padding-bottom:0.7rem;">
              <div class="fr" style="margin-right:0.5rem">
                <img v-lazy="imglist[3]" alt="" style="width:3.3rem;height:2.31rem;margin-top:0.1rem">
              </div>
              <div class="fr content_item_title2" style="margin-top:0.8rem;text-align:left">
                  <h3 class="content_item_title content_item_title1" v-html="$t('technology.text4')">
                    上行带宽节省70%
                  </h3>
                  <h3 class="content_item_title " v-html="$t('technology.text5')">
                    开启全民VR直播时代
                  </h3>
              </div>
          </div>
          <div class="content_item clearfix" style="padding-bottom:0.7rem;padding-top:0.5rem">
              <div class="fl">
                <img v-lazy="imglist[2]" alt="" style="width:3.4rem;height:2.2rem;margin-top:0.3rem">
              </div>
              <div class="fl content_item_title3" style="margin-top:0.9rem;margin-left:0.5rem;text-align:left;">
                  <h3 class="content_item_title content_item_title1" v-html="$t('technology.text8')">
                    下行带宽节省70%
                  </h3>
                  <h3 class="content_item_title" v-html="$t('technology.text9')">
                    4K高清不在话下
                  </h3>
              </div>
          </div>
        </div>

        
        <div class="content_item" style="background:#f3faff">
          <div class="content_item_title content_item_title1" v-html="$t('technology.text23')">
            专利音频编解码
          </div>

          <img v-lazy="imglist[7]" alt="" style="width:5.68rem;height:2.91rem;margin:0.4rem auto 0 auto">
        </div>
        <div class="content_item item_bg4" >
            <div class="content_item_title content_item_title1 white" style="margin-top:2.64rem;" v-html="$t('technology.text25')">
              下载体验Demo App
            </div>
            <div v-if="$i18n.locale=='en'" class="content_item_text " style="color:#fff;margin:0.3rem 0;font-size:0.22rem;margin-bottom:0">
              Experience our quality 4K streaming in sporting<br>
              events, concerts, and eSports through our demo. 
            </div>
            <div class="center" style="margin-bottom:0.3rem">
              <router-link to="/download"><a class="button_default"  v-html="$t('technology.text27')">下载Demo</a></router-link>
            </div>
            <div class="center">
              <router-link to="/solution" class="button_default" v-html="$t('technology.text28')">应用场景</router-link>
            </div>
        </div>
      </div>
      <footerLine></footerLine>
  </div>

</template>

<script>

import footerLine from "./footer";
import headerLine from "./header"
import Vue from 'vue'
import i18n from '../common/i18n'
export default {
  name: 'index',
  i18n:i18n,
  data () {
    return {
      imglist:[
        "/static/images/technology/T.png",
        "/static/images/technology/4K_main.png",
        "/static/images/technology/Upload_main.png",
        "/static/images/technology/Download_main.png",
        "/static/images/technology/Bg-1.png",
        "/static/images/technology/Low.png",
        "/static/images/technology/BG-2.png",
        "/static/images/technology/sound_main.png",
        "/static/images/technology/bg-3.png",
        "/static/images/technology/4K_main_en.png"


      ]
    }
  },
  watch:{

  },

  created () {
    var language = navigator.language; //取得浏览器版本语言
    var initLanguage = "";
    if(localStorage.locale){
      this.$i18n.locale = localStorage.locale;
    }else{
      if (language.indexOf('zh') > -1){
        initLanguage="ch"; //中文页面
      }else if (language.indexOf('en') > -1){
        initLanguage="en"; //英文页面
      }
      this.$i18n.locale = initLanguage;
    }
  },
  methods:{
    showDialog(){
      this.$refs.dialog.showDialog = true;
      this.$refs.dialog.showNext = false;
      if(this.$i18n.locale=="en"){
        this.$refs.dialog.content_type2 = "Get VRVIU Cloud Trial";

      }else{
        this.$refs.dialog.content_type2 = "申请使用威尔云";

      }
    },
    onLocaleChange:function(val){
      this.$i18n.locale=val;
    }
  },
  components:{
    headerLine,
    footerLine
  }
}
</script>

<style scoped>


.item_bg{
  background:url(../assets/images/technology/Bg-1.png) no-repeat;
  background-size: cover;
  height: 12.48rem;
  padding-bottom: 0.7rem;
}
.item_bg1{
  background:url(../assets/images/technology/Low.png) no-repeat;
  background-size: cover;
  height: 6.4rem;
}
.item_bg3{
  background:url(../assets/images/technology/BG-2.png) no-repeat;
  background-size: cover;
  height: 6.22rem;
}
.english .item_bg4{
  height: 7rem;
}
.item_bg4{
  background:#f3faff url(../assets/images/technology/bg-3.png) no-repeat;
  background-size: cover;
  height: 6.22rem;
}
.item_bg .content_item_title,.item_bg1 .content_item_title{
  text-align: left;
}
.banner_title{
  top:2rem;
}
.english .item_bg  .content_item_title,.english .item_bg1  .content_item_title,.english .item_bg2  .content_item_title {
    font-size: 0.26rem
}
.english .content_item item_bg4 .content_item_title.content_item_title1.white{
  margin-top: 1.98rem!important
}
.english .content_item_title2{
  margin-top:0.4rem!important;
}
.english .content_item_title3{
  margin-top:0.7rem!important;
}
.compareWords{
  font-size: 0.2rem;
  color:#505050;

}
.compareWords .center{
  line-height: 2em;
}
.compareWords .fl,.compareWords .fr{
  width: 50%
}
.compareWords a{
  font-size: 0.2rem!important;
  color:#1787fb!important;
}
</style>



// WEBPACK FOOTER //
// technology.vue?4a946d24